export default function logger(error) {
  const { type, stackError, error: msg } = error
  const errorMessage = type ? `${type}: ${stackError}` : stackError
  console.warn(msg || errorMessage || error)
}
